export const REPO_FORM_CONSTANTS = {
	DISTRIBUTION_REPO_TYPES:{
		RELEASE_BUNDLES: 'ReleaseBundles',
		BINTRAY: 'Distribution'
	},
	CONFIG: {
		RELEASE_BUNDLES: 'releaseBundlesRepoConfig',
		BINTRAY:'distributionRepoConfig',
	}
};


// WEBPACK FOOTER //
// ./states/admin/repositories/repository_form.constants.js